document.addEventListener('DOMContentLoaded', function() {
  BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_products_loaded', function(event){
    var elements = document.querySelectorAll('.bold_option_title');
    
    elements.forEach(function(element) {
        var text = element.textContent;
        var newText = text.replace('*', '');
        element.textContent = newText;
    });
  });
});


document.addEventListener('DOMContentLoaded', function() {
  BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_products_loaded', function(event){
    var dropdown = document.querySelector('select[name="properties[Color]"]');
    if (dropdown) {
      BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_changed', function(event){
        var selectedOption = dropdown.value;                
        var blackSwatch = document.querySelector('[id*="img-swatch-black"]');
        var vintageSwatch = document.querySelector('[id*="img-swatch-vintage"]');

        if (selectedOption.includes('Black')) {
            blackSwatch.click();
        } else if (selectedOption.includes('Vintage')) {
            vintageSwatch.click();
        }
      });
    }
  });
});